// extracted by mini-css-extract-plugin
module.exports = {"darkWrapper":"MainPage_darkWrapper__9Rn9s","wrapperWant":"MainPage_wrapperWant__60_5V","buttonColor":"MainPage_buttonColor__jXOqk"};